<template>
  <div class="tab content-tab">
    <Content
      v-if="items.length"
      :children="items"
      @positionChange="positionChanged"
      @delete="removeFormItem({ id, formItemId: $event })"
      @resize="sizeChanged($event.id, $event.size)"
    />

    <Button
      :disabled="cannotAddFormItem('Text')"
      icon="fas fa-plus"
      :label="$t('add-input')"
      @click="addFormItem({ id, type: 'Text' })"
    />
    <Button
      :disabled="cannotAddFormItem('Email')"
      icon="fas fa-plus"
      :label="$t('add-email-input')"
      @click="addFormItem({ id, type: 'Email' })"
    />
    <Button
      :disabled="cannotAddFormItem('Phone')"
      icon="fas fa-plus"
      :label="$t('add-phone-input')"
      @click="addFormItem({ id, type: 'Phone' })"
    />
    <Button
      v-if="!canAddButton"
      icon="fas fa-plus"
      :label="$t('add-button')"
      @click="addFormItem({ id, type: 'Button' })"
    />

    <div class="items" :class="`form-item-${item.type}`" v-for="{ item } in items" :key="item.id">
      <FormItem :formId="id" :item="item" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContentMixin from '@/components/sidenav/landing/shared/ContentMixin.js'
import Button from '@/shared/components/Button'
import FormItem from './FormItem'
import Content from '@/components/sidenav/shared/Content'
import Mixin from '@/components/Mixin.js'

export default {
  components: { FormItem, Button, Content },
  i18nOptions: { keyPrefix: 'components.sidenav.landing.form.content' },
  mixins: [ContentMixin, Mixin],
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    ...mapGetters('landing', ['active']),
    canAddButton() {
      return !this.items.some(i => i.type === 'Button')
    },
  },
  methods: {
    ...mapActions('landing', ['updateFormItem', 'updateFormItemPosition', 'addFormItem', 'removeFormItem']),
    positionChanged({ moved }) {
      this.updateFormItemPosition({
        id: this.id,
        formItemId: moved.element.id,
        from: moved.oldIndex,
        to: moved.newIndex,
      })
    },
    sizeChanged(formItemId, value) {
      this.updateFormItem({
        id: this.id,
        formItemId,
        path: `size.${this.currentView}`,
        value,
      })
    },
    cannotAddFormItem(type) {
      return this.isFromFunnel && this.items.some(i => i.item.type === type)
    },
  },
}
</script>
<style lang="scss" scoped>
.items {
  margin: 2rem 5px;
}
</style>
